export default "__VITE_ASSET__01d95e53__"